import styled from 'styled-components';

export const Container = styled.div`
  width: ${({width}) => width || '100%'};
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SwapContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
